import { useTranslation } from 'react-i18next';
import React, {useState, useEffect,Fragment} from 'react';
import { useParams } from "react-router-dom";
import apiRequest from '../../functions/api';
import { Paper, Typography,Table,TableBody,TableCell,TableContainer,TableHead,TableRow} from "@mui/material";
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from '../../context/message-context';
import { LOCAL_STORAGE_KEY } from '../../constants/localStorage';
import { useSessionStorage } from '../../utils/hooks';
function ToDosDetails() {
  const { t } = useTranslation();
  let { todokey } = useParams();
  const [aufgaben, setAufgaben] = useState([]);
  const [accessToken,] = useSessionStorage(LOCAL_STORAGE_KEY.accessToken);
  const [isLoading, setIsLoading] = useState(false);
  const {hideMessage, showErrorMessage} = useMessage();
  const ladeDocuments = () => {
    setIsLoading(true);
    const payload={
      "statement": "LESE_AUFGABE",
      "aufgabe": todokey,     
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'aufgaben', payload, headers, aufgabenCb);
  }
  useEffect(() => {
    ladeDocuments()
    // eslint-disable-next-line
  }, [])
  
  const aufgabenCb = (response) => {
    if (response.status === 200) {
        if (response.data.aufgaben) {
            setAufgaben(response.data.aufgaben);
        } else {
            setAufgaben([]);
        }
        setIsLoading(false);
        hideMessage();
    } else {
        if (response) {
          showErrorMessage(response.data.message);
        } else {
          showErrorMessage(t("Keine Internetverbindung"));
        }
    }      
}
  if (isLoading) {
    return <LoadingComponent />
  }
  const dataRequest = (aufgaben.length>0) ? aufgaben.map((element) => {
    return (
        <Fragment>   
           {element.datum.map((antwort)=> {
            return (
              <TableRow  
                hover
              >
              <TableCell>{element.bezeichnung}</TableCell>
              <TableCell>{element.status}</TableCell>
              <TableCell>{antwort.datum + " - " + antwort.termin}</TableCell>
              </TableRow> 
            )
          }) }   
        </Fragment>  
    )
  })
  :
    <TableRow  > 
      <Typography variant="body1">{t("Es wurden keine Aufgaben gefunden")}</Typography>
    </TableRow>
  ;
  return (
    <div>
      <TableContainer component={Paper}>
       <Table>
         <TableHead>
           <TableRow>
              <TableCell>{t("Bezeichnung")}</TableCell>
              <TableCell>{t("Status")}</TableCell>
              <TableCell>{t("Erledigungszeitraum")}</TableCell>
            </TableRow>
           </TableHead>           
         <TableBody>
           { dataRequest }        
         </TableBody> 
       </Table>
      </TableContainer>
    </div>
  )
}
export default ToDosDetails;
